import * as React from 'react'

export const useModal = () => {
  const [showModal, handleModal] = React.useState<boolean>(false)

  return { showModal, handleModal }
}



// WEBPACK FOOTER //
// ./src/utils/hooks/useModal.ts